import React, { useState, useEffect } from "react"
import Card from "@mui/material/Card"
import { Button, Checkbox, MenuItem, TextField } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { mapbox_to_geojson } from "../utils/layer_actions"

const get_managing_facility_options = (fac_geo_json) => {
  const allowed_types = ["district", "private_acute", "regional"]
  const options = fac_geo_json.features
    .filter(({ properties: { type } }) => allowed_types.includes(type))
    .map(({ id, properties: { name } }) => ({ id, name }))
  return options
}

export default function EditCup({
  current_edit_cup,
  fac_geo_json,
  dispatch_map_data,
  dispatch_ui,
}) {
  const [form_data, set_form_data] = useState(null)

  useEffect(() => {
    if (!current_edit_cup) {
      return
    }
    let { properties } = current_edit_cup
    if (!("managing_fac_id" in properties)) {
      properties.managing_fac_id = null
    }
    set_form_data(properties)
  }, [current_edit_cup])

  const handle_change = (property, value) => {
    let new_form_data = { ...form_data }
    new_form_data[property] = value
    set_form_data(new_form_data)
  }

  if (!current_edit_cup || !form_data) {
    return null
  }

  const managing_facility_options = get_managing_facility_options(fac_geo_json)

  return (
    <Card
      style={{
        position: "absolute",
        top: "70px",
        right: "10px",
        zIndex: 500,
        maxHeight: 500,
        overflow: "auto",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <b>CUP Property</b>
            </TableCell>
            <TableCell align="right">
              <b>Value</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Name
            </TableCell>
            <TableCell component="th" scope="row">
              <TextField
                value={form_data.name}
                variant="standard"
                size="small"
                onChange={(event) => {
                  handle_change("name", event.target.value)
                }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Fixed
            </TableCell>
            <TableCell component="th" scope="row" align="center">
              <Checkbox
                checked={form_data.fixed}
                onChange={(event) => {
                  handle_change("fixed", event.target.checked)
                }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Managing Facility
            </TableCell>
            <TableCell component="th" scope="row" align="center">
              <TextField
                value={
                  form_data.managing_fac_id === null
                    ? ""
                    : form_data.managing_fac_id
                }
                select
                fullWidth
                variant="standard"
                size="small"
                onChange={(event) => {
                  handle_change("managing_fac_id", event.target.value)
                }}
              >
                {managing_facility_options
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map(({ id, name }) => (
                    <MenuItem key={id} value={id}>
                      {name}
                    </MenuItem>
                  ))}
              </TextField>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Button
        onClick={() => {
          let cup = mapbox_to_geojson(current_edit_cup)
          cup = {
            ...cup,
            properties: { ...cup.properties, ...form_data },
          }
          dispatch_map_data({
            type: "UPDATE_CUP",
            payload: {
              cup,
            },
          })
          dispatch_ui({ type: "SET_EDIT_CUP", payload: { feature: null } })
        }}
        fullWidth
      >
        Update Local
      </Button>
      <Button
        onClick={() => {
          dispatch_ui({ type: "SET_EDIT_CUP", payload: { feature: null } })
        }}
        fullWidth
      >
        Cancel
      </Button>
    </Card>
  )
}
